import { render, staticRenderFns } from "./webstore-api-tokens.vue?vue&type=template&id=7407aaae&scoped=true&"
import script from "./webstore-api-tokens.vue?vue&type=script&lang=ts&"
export * from "./webstore-api-tokens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7407aaae",
  null
  
)

export default component.exports